import { appConfig } from "../config/config";

/**
 * Resolve an asset URL (logo, attachment, avatar) returned by the API.
 *
 * The backend stores uploaded files as root-relative paths like
 * "/uploads/logos/abc.png" and serves them from the API origin
 * (e.g. http://localhost:8000/uploads/...). Rendering such a path directly in
 * an <img src> makes the browser request it from the *frontend* origin, where
 * it 404s — so logos never appear. This prefixes relative paths with the API
 * base URL while leaving absolute/data/blob URLs untouched.
 */
export const resolveAssetUrl = (path) => {
  if (!path || typeof path !== "string") return path || null;
  // Already a full URL or in-memory preview — use as-is.
  if (/^(https?:|blob:|data:)/i.test(path)) return path;

  const rawBase = appConfig?.apiBaseUrl || process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
  const base = rawBase.replace(/\/api(\/v\d+)?\/?$/i, "").replace(/\/+$/, "");
  const rel = path.startsWith("/") ? path : `/${path}`;
  return `${base}${rel}`;
};

export default resolveAssetUrl;
